import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import { Drawer, DrawerClose, DrawerContent } from "@/components/Drawer";
import { Icon } from "@syarahtech/ui";
import { toast } from "sonner";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import WarrantyOptionRow from "./WarrantyOptionRow";
var WarrantySelectionDrawer = function WarrantySelectionDrawer(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    options = _ref.options,
    selectedId = _ref.selectedId,
    isDefaultSelected = _ref.isDefaultSelected,
    onConfirm = _ref.onConfirm;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(selectedId),
    localSelectedId = _useState[0],
    setLocalSelectedId = _useState[1];
  var _useState2 = useState(false),
    isConfirming = _useState2[0],
    setIsConfirming = _useState2[1];
  useEffect(function () {
    if (open) {
      setLocalSelectedId(selectedId);
    }
  }, [open]);

  // Confirm is disabled when on default and user hasn't picked something else
  var isConfirmDisabled = isDefaultSelected && localSelectedId === selectedId;
  var handleConfirm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var selected, success;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            selected = options.find(function (o) {
              return o.id === localSelectedId;
            });
            if (!(!selected || isConfirmDisabled)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setIsConfirming(true);
            _context.n = 2;
            return onConfirm(selected);
          case 2:
            success = _context.v;
            setIsConfirming(false);
            if (success) {
              onClose();
            } else {
              toast.error(tShort("remaining/error_try_again", {
                ns: "web_tracking"
              }));
            }
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleConfirm() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Drawer, {
    open: open,
    onOpenChange: function onOpenChange(isOpen) {
      return !isOpen && !isConfirming && onClose();
    },
    direction: "bottom"
  }, /*#__PURE__*/React.createElement(DrawerContent, {
    className: "!z-[500001] bg-white rounded-t-3xl px-4 pb-8 pt-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between pt-3 pb-1"
  }, /*#__PURE__*/React.createElement(DrawerClose, {
    asChild: true
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: isConfirming,
    className: "bg-transparent border-none cursor-pointer p-0 disabled:opacity-50"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-gray-text"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "bg-black h-1 w-12 rounded-full"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1 text-center mb-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-navy-primary text-base font-bold"
  }, tShort("remaining/change_warranty_duration", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-gray-mid text-xs font-semibold"
  }, tShort("remaining/choose_warranty_duration", {
    ns: "web_tracking"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 mb-4"
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(WarrantyOptionRow, {
      key: option.id,
      option: option,
      isSelected: localSelectedId === option.id,
      onSelect: function onSelect(o) {
        return setLocalSelectedId(o.id);
      }
    });
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-navy-primary text-xs font-medium text-center mb-5"
  }, tShort("remaining/warranty_longer_note", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleConfirm,
    disabled: isConfirmDisabled || isConfirming,
    className: "w-full bg-primary-new text-white text-base font-semibold py-3 px-4 rounded text-center disabled:opacity-50 cursor-pointer border-none flex items-center justify-center"
  }, isConfirming ? /*#__PURE__*/React.createElement(FLowLoadingSpinner, null) : tShort("remaining/confirm", {
    ns: "web_tracking"
  }))));
};
export default WarrantySelectionDrawer;